<template>
  <v-container class="modern-config-view">
    <!-- Split Header Layout -->
    <v-row class="mb-4 align-center px-4">
      <div class="d-flex align-center py-4">
        <v-btn icon color="primary" @click="$router.push('/products')" class="mr-4 grey lighten-4 shadow-sm">
          <v-icon small>fas fa-chevron-left</v-icon>
        </v-btn>
        <div>
          <div class="text-h4 font-weight-black primary--text d-flex align-center">
            Grupos y Unidades
          </div>
          <div class="caption grey--text font-weight-medium">Configuración de bases de costeo</div>
        </div>
      </div>
    </v-row>

    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-tabs 
        v-model="tab"
        background-color="grey lighten-5"
        color="primary"
        grow
        class="border-bottom"
      >
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-tags</v-icon>
          Grupos
        </v-tab>
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-balance-scale</v-icon>
          Unidades
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item class="pa-6">
          <group/>
        </v-tab-item>
        <v-tab-item class="pa-6">
          <unit/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import Group from '@/components/products/costs/Group'
import Unit from '@/components/products/costs/Unit'

export default {
  name: 'CostsGroupUnit',
  components: { Group, Unit },
  data: () => ({
    tab: null,
  })
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
.text-none { text-transform: none !important; }
.shadow-sm { box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important; }
</style>
